import { Box, H3, Icon, Separator, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { ThemedImage } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

import { DateRangeOption } from '../../../../graphql/schema';
import { DateRangeFilter } from '../../../shared/date-range-filter/DateRangeFilter';
import { PerformanceAccountQuery } from '../../graphql/performanceAccount.generated';

type HeaderProps = {
  dateRangeOption: DateRangeOption;
  account: PerformanceAccountQuery['performance']['accounts'][0];
  setDateRangeOption: (option: DateRangeOption) => void;
  returnToUrl: string;
  returnToLabel: string;
};

export const Header = ({ dateRangeOption, account, setDateRangeOption, returnToUrl, returnToLabel }: HeaderProps) => {
  const {
    icon: accountIcon,
    name: accountName,
    envelope: { purpose },
  } = account;
  const name = purpose?.name || accountName;
  const icon = purpose?.image || accountIcon;

  return (
    <Box css={{ paddingY: 'space.300' }}>
      <SambaAutoLink
        to={returnToUrl}
        css={{ display: 'flex', alignItems: 'center', gap: 'space.100', marginBottom: 'space.200' }}
      >
        <Icon name="CaretLeft" size="small" color="icon" />
        <Text color="text">{returnToLabel}</Text>
      </SambaAutoLink>
      <Box css={{ display: 'flex', alignItems: 'center', gap: 'space.150' }}>
        <Box css={{ width: 'size.450', height: 'size.450', flexShrink: 0 }}>
          <ThemedImage themedAsset={icon} alt={accountName} />
        </Box>
        <Box css={{ whiteSpace: 'nowrap' }}>
          <H3 variant="title200">{name}</H3>
          {purpose && (
            <Text variant="text50" color="text">
              {accountName}
            </Text>
          )}
        </Box>
      </Box>
      <Separator css={{ fullWidthWithInset: 'space.0', marginTop: 'space.300', marginBottom: 'space.300' }} />
      <DateRangeFilter onChange={setDateRangeOption} selected={dateRangeOption} />
    </Box>
  );
};
